const useStyle = () => {
    const getCSSValue = (cssVariableName: string): string => {
        const value = getComputedStyle(document.documentElement)
            .getPropertyValue(cssVariableName)
            .trim();

        if (value === '') {
            console.warn(`CSS variable ${cssVariableName} is not set`);
        }

        return value;
    };

    return {
        getCSSValue
    };
};

export default useStyle;
